import { useTranslation } from 'next-i18next';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const CTAContainer = styled.section<{ bgLoaded: boolean }>`
  background-image: ${(props) =>
    props.bgLoaded ? "url('https://res-front.pumpsoul.com/prod-erasa/image/erasa-bg-3.webp')" : 'none'};
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  transition: background-image 0.3s ease;

  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  margin: 2rem auto;

  @media (min-width: 768px) {
    margin-top: 5rem;
    padding: 3rem;
  }
`;

const Title = styled.h2`
  font-weight: bold;
  font-size: 42px;
  color: #02183a;
  line-height: 45px;
  text-align: center;
  font-style: normal;
  text-transform: none;

  @media (max-width: 768px) {
    font-size: 30px;
  }
`;

const Subtitle = styled.p`
  margin-top: 1.5rem;
  font-weight: 500;
  font-size: 18px;
  color: #02183a;
  line-height: 25px;
  text-align: center;
  font-style: normal;
  text-transform: none;
`;

const CTAButton = styled.button`
  margin-top: 3rem;
  background: linear-gradient(270deg, #ff47aa 0%, #aa56ff 30%, #418dff 80%);
  color: white;
  font-size: 1rem;
  font-weight: bold;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: scale(1.05);
  }
`;

const CamModelBottomContent = ({ onClick }: { onClick?: () => void }) => {
  const { t } = useTranslation();
  const [bgLoaded, setBgLoaded] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setBgLoaded(true);
          observer.disconnect();
        }
      });
    });
    const targetElement = document.querySelector('#cam-container');
    if (targetElement) {
      observer.observe(targetElement);
    }
  }, []);

  return (
    <CTAContainer bgLoaded={bgLoaded} id="cam-container">
      <Title>{t('Your Creative Journey Starts Here!')}</Title>
      <Subtitle>{t("Don't let piracy hold you back. Protect your creativity and income today!")}</Subtitle>
      <CTAButton onClick={onClick}>{t('Get Started with Your Free Trial')}</CTAButton>
    </CTAContainer>
  );
};

export default CamModelBottomContent;
